import { INSTRUMENT_GROUPS } from './groupColors';

const CORE = INSTRUMENT_GROUPS;
const STEPS = [
  ['Melodies', 'Melody'], ['Drums', 'Drums'], ['Textures', 'Texture'], ['Sound FX', 'Sound FX'],
];

export const COACH_MESSAGES = {
  Melodies: 'Pick a melody to start your beat.',
  Drums: 'Add drums that fit your melody.',
  Textures: 'Now add a texture to fill out the sound.',
  'Sound FX': 'Add a sound effect for some flavor.',
  bassline: 'All four are in! Want a bassline? I can write one.',
  send: 'Your beat is ready. Send it to Beat Arranger to make it a full song.',
};

const groupOf = (track) => track?.instrumentGroup || track?.instrument_group || track?.group;

export function coachSteps(tracks = [], hasKnock = false) {
  const groups = tracks.map(groupOf);
  const missing = CORE.filter((group) => !groups.includes(group));
  const current = missing[0] || (!hasKnock ? 'bassline' : 'send');
  const steps = [
    ...STEPS.map(([group, label]) => ({ key: group, group, label, done: groups.includes(group) })),
    { key: 'bassline', group: 'bassline', label: 'Bassline', done: hasKnock },
    { key: 'send', group: 'send', label: 'Send', done: false },
  ];
  const slots = tracks.slice(0, 8).map((track) => ({ type: 'track', track, group: groupOf(track) }));
  if (slots.length < 8) {
    missing.forEach((group, index) => {
      if (slots.length < 8) slots.push({ type: 'core', group, next: index === 0 });
    });
  }
  while (slots.length < 8) slots.push({ type: 'empty' });
  return { steps, current, message: COACH_MESSAGES[current], slots };
}

export default coachSteps;
